import React, { useEffect } from "react";
import { useLocation, useParams } from "react-router-dom";
import FinancialDomainContent from "../../components/agentic/FinancialDomainContent";
import ManufacturingDomainContent from "../../components/agentic/ManufacturingDomainContent";
import HRDomainContent from "../../components/agentic/HRDomainContent";
import BFSIDomainContent from "../../components/agentic/BFSIDomainContent";
import HealthcareDomainContent from "../../components/agentic/HealthcareDomainContent";
import LogisticsDomainContent from "../../components/agentic/LogisticsDomainContent";
import RetailDomainContent from "../../components/agentic/RetailDomainContent";
import InsuranceDomainContent from "../../components/agentic/InsuranceDomainContent";
import TelecomDomainContent from "../../components/agentic/TelecomDomainContent";
import PublicSectorDomainContent from "../../components/agentic/PublicSectorDomainContent";
import RealEstateDomainContent from "../../components/agentic/RealEstateDomainContent";
import HospitalityDomainContent from "../../components/agentic/HospitalityDomainContent";
import AgricultureDomainContent from "../../components/agentic/AgricultureDomainContent";
import ITServicesDomainContent from "../../components/agentic/ITServicesDomainContent";
import AviationDomainContent from "../../components/agentic/AviationDomainContent";
import PharmaDomainContent from "../../components/agentic/PharmaDomainContent";
import MediaDomainContent from "../../components/agentic/MediaDomainContent";
import EnergyDomainContent from "../../components/agentic/EnergyDomainContent";
import EducationDomainContent from "../../components/agentic/EducationDomainContent";
import AutomotiveDomainContent from "../../components/agentic/AutomotiveDomainContent";
import { AGENTIC_AI_DOMAINS } from "../../data/agenticDomains";
import { FINANCIAL_DOMAIN_INTRO } from "../../data/financialUseCases";
import { MANUFACTURING_DOMAIN_INTRO } from "../../data/manufacturingUseCases";
import { HR_DOMAIN_INTRO } from "../../data/hrUseCases";
import { BFSI_DOMAIN_INTRO } from "../../data/bfsiUseCases";
import { HEALTHCARE_DOMAIN_INTRO } from "../../data/healthcareUseCases";
import { LOGISTICS_DOMAIN_INTRO } from "../../data/logisticsUseCases";
import { RETAIL_DOMAIN_INTRO } from "../../data/retailUseCases";
import { INSURANCE_DOMAIN_INTRO } from "../../data/insuranceUseCases";
import { TELECOM_DOMAIN_INTRO } from "../../data/telecomUseCases";
import { PUBLIC_SECTOR_DOMAIN_INTRO } from "../../data/public-sectorUseCases";
import { REAL_ESTATE_DOMAIN_INTRO } from "../../data/real-estateUseCases";
import { HOSPITALITY_DOMAIN_INTRO } from "../../data/hospitalityUseCases";
import { AGRICULTURE_DOMAIN_INTRO } from "../../data/agricultureUseCases";
import { IT_SERVICES_DOMAIN_INTRO } from "../../data/it-servicesUseCases";
import { AVIATION_DOMAIN_INTRO } from "../../data/aviationUseCases";
import { PHARMA_DOMAIN_INTRO } from "../../data/pharmaUseCases";
import { MEDIA_DOMAIN_INTRO } from "../../data/mediaUseCases";
import { ENERGY_DOMAIN_INTRO } from "../../data/energyUseCases";
import { EDUCATION_DOMAIN_INTRO } from "../../data/educationUseCases";
import { AUTOMOTIVE_DOMAIN_INTRO } from "../../data/automotiveUseCases";

const LIVE_DOMAIN_CONTENT = {
  financial: FinancialDomainContent,
  manufacturing: ManufacturingDomainContent,
  hr: HRDomainContent,
  bfsi: BFSIDomainContent,
  healthcare: HealthcareDomainContent,
  logistics: LogisticsDomainContent,
  retail: RetailDomainContent,
  insurance: InsuranceDomainContent,
  telecom: TelecomDomainContent,
  "public-sector": PublicSectorDomainContent,
  "real-estate": RealEstateDomainContent,
  hospitality: HospitalityDomainContent,
  agriculture: AgricultureDomainContent,
  "it-services": ITServicesDomainContent,
  aviation: AviationDomainContent,
  automotive: AutomotiveDomainContent,
  pharma: PharmaDomainContent,
  media: MediaDomainContent,
  energy: EnergyDomainContent,
  education: EducationDomainContent,
};

const DOMAIN_INTRO = {
  financial: FINANCIAL_DOMAIN_INTRO,
  manufacturing: MANUFACTURING_DOMAIN_INTRO,
  hr: HR_DOMAIN_INTRO,
  bfsi: BFSI_DOMAIN_INTRO,
  healthcare: HEALTHCARE_DOMAIN_INTRO,
  logistics: LOGISTICS_DOMAIN_INTRO,
  retail: RETAIL_DOMAIN_INTRO,
  insurance: INSURANCE_DOMAIN_INTRO,
  telecom: TELECOM_DOMAIN_INTRO,
  "public-sector": PUBLIC_SECTOR_DOMAIN_INTRO,
  "real-estate": REAL_ESTATE_DOMAIN_INTRO,
  hospitality: HOSPITALITY_DOMAIN_INTRO,
  agriculture: AGRICULTURE_DOMAIN_INTRO,
  "it-services": IT_SERVICES_DOMAIN_INTRO,
  aviation: AVIATION_DOMAIN_INTRO,
  automotive: AUTOMOTIVE_DOMAIN_INTRO,
  pharma: PHARMA_DOMAIN_INTRO,
  media: MEDIA_DOMAIN_INTRO,
  energy: ENERGY_DOMAIN_INTRO,
  education: EDUCATION_DOMAIN_INTRO,
};

const DOMAIN_KEYWORDS = {
  financial:
    "financial domain AI automation, accounts payable, accounts receivable, procure to pay, order to cash, treasury, tax automation, FP&A, general ledger close, expense management, audit automation, finance shared services, agentic AI",
  manufacturing:
    "manufacturing AI automation, production order planning, cable manufacturing, automotive components, electronics manufacturing, chemicals, plastics, packaging, textiles, industrial machinery, metal fabrication, food manufacturing, pharma manufacturing, process manufacturing, BOM capacity planning, agentic AI, manufacturing RPA services",
  hr:
    "hr domain agentic AI workflow automation, recruitment, onboarding, payroll support, attendance leave, performance management, employee query handling, training, HR compliance, offboarding, employee engagement, job description assistant, resume screening, IT access automation, HR helpdesk triage, policy knowledge assistant, resignation intake, full and final settlement, exit interview insights, HRMS Workday SuccessFactors Darwinbox, agentic AI India UAE KSA UK USA",
  bfsi:
    "bfsi agentic AI workflow automation, retail banking, corporate banking, lending nbfc, insurance, payments fintech, KYC AML compliance, risk management, trade finance, collections, customer service, dormant account reactivation, debit card dispute intake, corporate query triage, AML alert triage, underwriting risk summary, service request classification, complaint summary root cause, knowledge assistant, omnichannel response drafting, product recommendation support, agentic AI India UAE KSA UK USA",
  healthcare:
    "healthcare agentic AI workflow automation, clinics, diagnostics, revenue cycle, insurance support, clinical documentation, pharmacy, patient communication, diagnostics imaging, clinic billing pre-check, abnormal result escalation, medical coding support, claim scrubbing, appeal letter drafting, doctor note summarization, medication substitution approval, patient query triage, prior scan retrieval, HIS EMR EHR LIS RIS PACS, agentic AI India UAE KSA UK USA",
  logistics:
    "logistics agentic AI workflow automation, freight forwarding, courier parcel, customs brokerage, cold chain logistics, e-commerce logistics, supply chain control tower, enquiry-to-quote automation, delivery exception classification, HS code suggestion, customs query response pack, cold chain incident summary, failed delivery customer communication, exception management agent, SLA root cause analysis, TMS WMS ERP, agentic AI India UAE KSA UK USA",
  insurance:
    "insurance, agentic AI, underwriting submission summarization, suspicious claim signal summarization, litigation case summarization, agentic AI India UAE KSA UK USA",
  telecom:
    "telecom, agentic AI, network alarm triage, incident postmortem summary, enterprise quote to order automation, agentic AI India UAE KSA UK USA",
  "public-sector":
    "public sector & government, agentic AI, rti or foi response drafting support, municipal case summary assistant, agentic AI India UAE KSA UK USA",
  "real-estate":
    "real estate & construction, agentic AI, tender document review, variation order impact summary, agentic AI India UAE KSA UK USA",
  hospitality:
    "hospitality & travel, agentic AI, cancellation and refund workflow, banquet inquiry to quote, agentic AI India UAE KSA UK USA",
  agriculture:
    "agriculture & food processing, agentic AI, customer complaint traceability, agentic AI India UAE KSA UK USA",
  "it-services":
    "it & technology services, agentic AI, incident root cause assistant, soc alert enrichment, rfp response assistant, pipeline failure triage, employee onboarding access workflow, agentic AI India UAE KSA UK USA",
  aviation:
    "aviation & aerospace, agentic AI, mro work order planning, safety incident report summary, agentic AI India UAE KSA UK USA",
  automotive:
    "automotive, agentic AI, ev battery traceability and risk alerts, warranty claim triage and root cause analytics, engineering change impact assessment, agentic AI India UAE KSA UK USA",
  pharma:
    "pharma, agentic AI, batch record review and exception detection, agentic AI India UAE KSA UK USA",
  media:
    "media & entertainment, agentic AI, subtitling and localization workflow, social listening and response routing, agentic AI India UAE KSA UK USA",
  energy:
    "energy & utilities, agentic AI, field service dispatch optimization, agentic AI India UAE KSA UK USA",
  education:
    "education agentic AI use cases — assignment rubric feedback, timetable generation, placement resume matching, LMS helpdesk, student grievance routing, parent communication. LMS SIS CRM integration.",
  retail:
    "retail agentic AI workflow automation, e-commerce, fashion retail, electronics retail, inventory management, POS store finance, customer loyalty, omnichannel retail, pricing promotions, loss prevention, order exception management, returns eligibility validation, product catalog content generation, auto-replenishment, refund approval workflow, personalized offer recommendation, markdown recommendation, store incident report assistant, POS OMS WMS ERP CRM, agentic AI India UAE KSA UK USA",
};

function ComingSoon({ label }) {
  return (
    <section
      style={{
        maxWidth: 720,
        margin: "80px auto",
        padding: "0 35px",
        textAlign: "center",
      }}
    >
      <h1
        style={{
          fontFamily: "Exo, sans-serif",
          fontSize: 32,
          color: "#0b3475",
          marginBottom: 12,
        }}
      >
        {label}
      </h1>
      <p style={{ color: "#5d7493", fontSize: 16, lineHeight: 1.7 }}>
        Use cases for this domain are coming soon. Live content is available under{" "}
        <strong>Financial Domain</strong>, <strong>Manufacturing</strong>,{" "}
        <strong>HR Domain</strong>, <strong>BFSI</strong>, and <strong>Healthcare</strong>.
      </p>
    </section>
  );
}

export default function AgenticAIDomains() {
  const location = useLocation();
  const { domainSlug } = useParams();
  const domainLabel = location.state?.domain;
  const activeDomain =
    AGENTIC_AI_DOMAINS.find((d) => d.slug === domainSlug)?.id ||
    AGENTIC_AI_DOMAINS.find((d) => d.label === domainLabel)?.id ||
    "financial";

  useEffect(() => {
    const intro = DOMAIN_INTRO[activeDomain];
    const hasLiveContent = Boolean(LIVE_DOMAIN_CONTENT[activeDomain]);

    if (intro && hasLiveContent) {
      return;
    }

    if (intro) {
      document.title = `${intro.title} | Agentic AI | Surens Inffotek`;
      const meta = document.querySelector('meta[name="description"]');
      if (meta) {
        meta.setAttribute("content", intro.seoDescription);
      }
      const keywords = DOMAIN_KEYWORDS[activeDomain];
      if (keywords) {
        let keywordsMeta = document.querySelector('meta[name="keywords"]');
        if (!keywordsMeta) {
          keywordsMeta = document.createElement("meta");
          keywordsMeta.name = "keywords";
          document.head.appendChild(keywordsMeta);
        }
        keywordsMeta.setAttribute("content", keywords);
      }
      return;
    }
    const match = AGENTIC_AI_DOMAINS.find((d) => d.id === activeDomain);
    document.title = match
      ? `${match.label} | Agentic AI | Surens Inffotek`
      : "Agentic AI | Surens Inffotek";
  }, [activeDomain]);

  const DomainContent = LIVE_DOMAIN_CONTENT[activeDomain];
  const isLiveDomain = Boolean(DomainContent);

  return (
    <div style={{ background: isLiveDomain ? "#27baa7" : "#fff", minHeight: "60vh" }}>
      <main>
        {DomainContent ? (
          <DomainContent />
        ) : (
          <ComingSoon
            label={AGENTIC_AI_DOMAINS.find((d) => d.id === activeDomain)?.label}
          />
        )}
      </main>
    </div>
  );
}

